var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.857 4.57129C9.17636 4.57129 4.57129 9.17636 4.57129 14.857C4.57129 20.5376 9.17636 25.1427 14.857 25.1427C17.2856 25.1427 19.5176 24.301 21.2772 22.8935L26.0489 27.6651C26.4952 28.1114 27.2188 28.1114 27.6651 27.6651C28.1115 27.2188 28.1115 26.4952 27.6651 26.0489L22.8935 21.2772C24.301 19.5176 25.1427 17.2856 25.1427 14.857C25.1427 9.17636 20.5376 4.57129 14.857 4.57129ZM6.857 14.857C6.857 10.4387 10.4387 6.857 14.857 6.857C19.2753 6.857 22.857 10.4387 22.857 14.857C22.857 19.2753 19.2753 22.857 14.857 22.857C10.4387 22.857 6.857 19.2753 6.857 14.857Z",
    fill: "#0D1137"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.ecb2989481f152476f87dfd0aa8da984.svg";
export { ForwardRef as ReactComponent };